import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    desktop: 'grid gap-3 max-md:hidden md:grid-cols-4 lg:grid-cols-6',
    mobile: 'md:hidden',
    mobilePreview: 'relative aspect-351/188 w-full overflow-hidden rounded-[16px]',
    mobilePreviewImage: 'object-cover',
    mobileSlider:
      '-mx-3 mt-5 w-[calc(100%+24px)] [--slide-size:102px] [--slide-spacing:8px] sm:[--slide-size:152px]',
    mobileSliderViewport: 'px-3.5 py-0.5'
  }
});
